export default [
  {label: '원', value: 'KRW'},
  {label: 'USD', value: 'USD'},
  {label: 'JPY', value: 'JPY'},
];
